import React, { lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Addington from "../../Components/Addington";
import Competition from "../../Components/Competition";
import LeaderBoard from "../../Components/LeaderBoard";
import RaceCardSlider from "../../Components/RaceCardSlider";
import RaceCardPostSection from "../../Components/RaceCardPostSection";
import LatestWinnersCard from "../../Components/LatestWinnersCard";
import PredictionSection from "../../Components/PredictionSection";
import RecentActivitiesCard from "../../Components/RecentActivitiesCard";
import Slider from "../../Components/Slider";
import { fetchRace } from "../../../../redux/getReducer/getRaceCard";
import Sponsor from "../../Components/Sponsor";
import WinningList from "../../Components/WinningList";
import UpcomingRaceCard from "../../Components/UpcomingRaceCard";
import HomeCenterSubSection from "../../Section/HomeCenterSubSection";
import Banner from "../Banner";
import CurrentSection from "../CurrentPost";
import HomeTabs from "./HomeTabs";
import Search from "../../Components/Search";
import arabianImg from "../../../../assets/arabian.png";
import coverImage from "../../../../assets/hero.png";
import HowToRegister from "../../Section/HowToRegister";
// import "./HomeLayout.css"; 
const Ads = lazy(() => import("../../Components/Ads"));

const HomeLayout = () => {
  const { id, date } = useParams();
  const { t, i18n } = useTranslation();

  const { data: racecard, status } = useSelector((state) => state.racecard);
  const [raceCardData, setRaceCardData] = useState(null);

  const [activeTab, setActiveTab] = useState("Live");

  useEffect(() => {
    if (racecard && racecard.length > 0) {
      const matchedRace = racecard.find((rc) => rc._id === id);
      const dataToSet = matchedRace || racecard[0];
      setRaceCardData(dataToSet);
    }
  }, [racecard, id]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRace());
  }, [dispatch]);

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div className="saddle-battle-unique-home-wrapper">
        <div className="container-fluid">
          <div className="row position-relative hero-section-row">
            <div className="hero-slider-bg-container">
              <div className="saddle-battle-slider-wrapper">
                <img className="d-block slideimg1" src={coverImage} alt="First slide" />
              </div>
            </div>

            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center mobile-spacing-hero hero-content-col">
              <div className="align-items-center d-flex justify-content-center left-sectio-slider w-100 h-100">

                <div className="left-section-content desktop-text-wrapper">
                  <Search />
                  <h2 className="custome-heading">
                    {i18n.language === "en" ? (
                      <>
                        Worlds's First Multi-Lingual Platform for{" "}
                        <span className="heading-arabian">Arabian </span> &
                        Thoroughbred Racing
                      </>
                    ) : (
                      <>
                        اول منصة متعددة اللغات في العالم لسباقات الخيول{" "}
                        <span className="heading-arabian">العربية </span> والاصيلة
                      </>
                    )}
                  </h2>
                  <p className="custome-heading-paragraph">
                    {t("hero_description")}
                  </p>
                </div>
              </div>
            </div>

            <div className="row secontabs mt-md-3">

              <div className="col-12 col-lg-8 custom-space-y-2 order-xl-1 order-2">
                <HomeTabs raceCardData={raceCardData} />

                <div className="row racesliderrow">
                  {/* <RaceCardPostSection /> */}

                  <PredictionSection />

                </div>


              </div>


              <div className="col-12 col-lg-4  sha-upsight mt-5 mt-lg-0 order-xl-2 order-1">
                <CurrentSection setRaceCardData={setRaceCardData} />

                <div className="sha-scroll">
                  <Competition />
                  <LeaderBoard />
                  <WinningList />
                </div>
              </div>
            </div>

            <div className="row banns mt-3 mt-md-3">

              <div className="col-12 pre-next-btn-newone">
                <HowToRegister />
                <Banner />
                {/* <HomeCenterSubSection /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

    </React.Suspense>
  );
};

export default HomeLayout;